<template>
  <div
    id="print-dialog"
  />
</template>

<script setup>
import {inject} from 'vue';
import {jsPDF as JsPDF} from 'jspdf';
import html2canvas from 'html2canvas';
// #region Props, Emits
// #endregion

// #region Params, Ref, Reactives, Computed
const mapRef = inject('instancePrintMapRef');

async function printMap(width, height, dims, quality = 1) {
  // export options for html2canvas
  // See: https://html2canvas.hertzen.com/configuration
  const baseExportOptions = {
    useCORS: true,
    backgroundColor: null,
  };
  const mapExportOptions = {
    ...baseExportOptions,
    width,
    height,
    ignoreElements: function(element) {
      const className = element?.className ?? null;
      if (!className || className.length <= 0 || typeof className !== 'string') {
        return false;
      }

      const hasControl = className?.includes('ol-control') ?? false;
      const hasScale = className?.includes('ol-scale') ?? false;
      const hasAttribution = className?.includes('ol-attribution') ?? false;
      const hasUncollapsible = className?.includes('ol-uncollapsible') ?? false;
      return (hasControl && !hasScale &&(!hasAttribution ||!hasUncollapsible));
    },
  };
  const compressionOption = 'FAST';
  if (!!mapRef?.value) {
    const map = mapRef.value;
    const scaleElement = document.getElementById('print-scale-bar');
    const bcr = scaleElement.getBoundingClientRect();
    const scaleWidth = bcr.width;
    const scaleHeight = bcr.height;
    const scaleExportOptions = {
      ...baseExportOptions,
      width: scaleWidth,
      height: scaleHeight,
    };

    const canvasMap = await html2canvas(map.getViewport(), mapExportOptions);
    const canvasScale = await html2canvas(scaleElement, scaleExportOptions);

    // create pdf
    const pdf = new JsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });

    // add map to pdf
    pdf.addImage(
      canvasMap,
      'PNG',
      0,
      0,
      dims[0],
      dims[1],
      'moc',
      compressionOption,
    );
    // Add scale to pdf
    // Percentages for scale
    const percWidthScale = canvasScale.width / canvasMap.width;
    const percHeightScale = canvasScale.height / canvasMap.height;
    // Scale widths and height in mm
    const widthScaleMM = percWidthScale * dims[0];
    const heightScaleMM = percHeightScale * dims[1];
    const topScaleMM = dims[1] - heightScaleMM - 10;
    // const leftScaleMM = dims[0] - widthScaleMM;
    pdf.addImage(
      canvasScale,
      'PNG',
      5, // mm from left
      topScaleMM, // mm from top
      widthScaleMM,
      heightScaleMM,
      'escala',
      compressionOption,
    );

    // logo image
    const logoImage = new Image();
    logoImage.src = '/statics/images/logo.png';
    await new Promise((resolve, reject) => {
      logoImage.onload = resolve;
      logoImage.onerror = reject;
    });
    // add logo to pdf
    pdf.addImage(logoImage, 'PNG', 0, 0, 75, 18, 'logo', compressionOption);

    // print pdf
    const blob = pdf.output('blob', 'Mapa.pdf');
    return blob;
  }
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
defineExpose({
  printMap,
});
// #endregion
</script>

<style lang="scss" scoped>
</style>
